export default __webpack_public_path__ + "static/media/imone-img.e0776422.webp";